/* eslint-disable react/destructuring-assignment */
import { IconClearAll, IconRecycle, IconSearch } from '@tabler/icons-react';
import { Button, Group, Paper, SimpleGrid, Space, TextInput } from '@mantine/core';
import { useForm } from '@mantine/form';

type FilterData = {
  residuoTratamento: string;
};

type FilterProps = {
  filter(data: FilterData): void;
  clear(): void;
  loading: boolean;
};

function Filter(props: FilterProps) {
  const form = useForm<FilterData>({
    initialValues: {
      residuoTratamento: '',
    },
  });

  return (
    <form onSubmit={form.onSubmit(props.filter)}>
      <Paper shadow="xs" p="md" withBorder>
        <SimpleGrid cols={5}>
          <TextInput
            leftSection={<IconRecycle size={15} />}
            label="Tratamento"
            description="Filtro: contém"
            placeholder="Todos..."
            maxLength={500}
            {...form.getInputProps('residuoTratamento')}
          />
          <Group>
            <Button
              style={{ marginTop: 44 }}
              color="secondary"
              leftSection={<IconClearAll size={18} />}
              disabled={props.loading}
              onClick={() => {
                form.reset();
                props.clear();
              }}
            >
              Limpar
            </Button>
            <Button
              style={{ marginTop: 44 }}
              leftSection={<IconSearch size={18} />}
              type="submit"
              loading={props.loading}
            >
              Pesquisar
            </Button>
          </Group>
        </SimpleGrid>
      </Paper>
      <Space h="xl" />
    </form>
  );
}

export { Filter };
export type { FilterData };
